import { FeedbotDispatch, FeedbotThunk } from './types'
import { StepTreePathChain } from '../features/stepTreePathChain'
import { actions as dialogStepActions } from './dialogSteps/dialogStepsSlice'

export const collapseRootDialogWithAllSubdialogs =
  (dialogId: string): FeedbotThunk =>
  (dispatch: FeedbotDispatch) => {
    const path = new StepTreePathChain().attachNewLink(dialogId).getPath()
    dispatch(dialogStepActions.removeExpandedDialog(path))
  }
